export default __webpack_public_path__ + "static/media/test2.748ea080.png";